export default __webpack_public_path__ + "static/media/MP5_4_1.7d91bc4c.png";